import React, { useEffect, useRef, useState } from "react";
import "./DeleteAccountModal.css";

const MIN_PASSWORD_LENGTH = 8;

const DeleteAccountModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [passwordValue, setPasswordValue] = useState("");
  const modalRef = useRef(null);

  // При каждом открытии поле чистое
  useEffect(() => {
    if (!isOpen) return;
    setPasswordValue("");
  }, [isOpen]);

  // Закрытие по клику вне окна и по Escape
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const isPasswordValid = passwordValue.length >= MIN_PASSWORD_LENGTH;

  return (
    <div className="delete-acc-modal-overlay">
      <div className="delete-acc-modal" ref={modalRef}>
        <button
          className="delete-acc-close-button"
          onClick={onClose}
          disabled={isLoading}
          aria-label="Закрыть"
        />

        <h1 className="delete-acc-modal-title">Удаление аккаунта</h1>

        <div className="delete-acc-modal-content">
          <p className="delete-acc-warning">
            Вы действительно хотите удалить этот аккаунт? Ваши данные будут
            храниться у нас в течение 90 дней, после чего будут удалены.
            Действие необратимо.
          </p>

          <p className="delete-acc-hint">
            {`Чтобы подтвердить удаление, введите свой пароль ниже`}
          </p>

          <input
            className="delete-acc-input"
            type="password"
            placeholder="Ваш пароль"
            value={passwordValue}
            onChange={(e) => setPasswordValue(e.target.value)}
            disabled={isLoading}
            autoFocus
          />
        </div>

        <button
          onClick={() => onConfirm(passwordValue)}
          className="delete-acc-submit-button"
          disabled={!isPasswordValid || isLoading}
        >
          {isLoading ? "Удаление..." : "Удалить аккаунт"}
        </button>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
